import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);


if (document.querySelector('.magazine--generations')) {
	var textItems = document.querySelectorAll('.generations__content-item')

	textItems.forEach(function(textItem) {
		ScrollTrigger.create({
		  trigger: textItem,
		  start: "top 50%",
		  end: "bottom 0%",
		  scrub: true,
	      onEnter: () => textItem.classList.add('is-active')
		});
	})
}